<template>
  <InstructionScreen :title="'Total points'">
    You have completed the experiment! 
    <br />
    You have earned a total of {{ totalPoints }} out of 32 points across all trials ({{ Math.round(totalPoints / 32 * 100) }}%).
    <br />
    <Record
          :data="{
            total_points: totalPoints,
            total_points_percentage: Math.round(totalPoints / 32 * 100)
          }", global="true"
        />
    Please click 'Next' to proceed to the post-test questionnaire and submit the results.
  </InstructionScreen>
</template>

<script>
{/* import Record from 'magpie-base/src/helpers/Record'; */}

export default {
  name: 'TotalPointsScreen',
//   components: {
//     Record
//   },
  data() {
    return {
      totalPoints: 0
    };
  },
  computed: {
    recordData() {
      return {
        total_points: this.totalPoints,
        total_points_percentage: Math.round(this.totalPoints / 32 * 100)
      };
    }
  },
  mounted() {
    this.calculateTotalPoints();
  },
  methods: {
    calculateTotalPoints() {
      console.log('=== calculateTotalPoints called ===');
      console.log('$magpie object:', this.$magpie);
      console.log('$magpie.getAllData():', this.$magpie.getAllData());
      
      let totalPoints = 0;
      const trialResults = this.$magpie.getAllData();
      console.log('trial results in calculateTotalPoints:');
      console.log(trialResults);
      
      // Iterate over all trial results
      for (let i = 0; i < trialResults.length; i++) {
        const result = trialResults[i];

        // skip filler trials
        if (result.type === 'filler') {
            console.log("Skipping filler trial", i + 1);
          continue;
        }
        
        // Determine the correct answer based on trial's should_abstain flag
        const correctAnswer = result.correct_answer === 'Not solvable' 
          ? 'Not definitively answerable' 
          : 'Answerable';
        console.log(`Trial ${i + 1}: correct answer is "${correctAnswer}"`);
        
        const userAnswer = result.fc;
        console.log(`Trial ${i + 1}: user answer is "${userAnswer}"`);
        
        // Check if the answer is correct
        const isCorrect = userAnswer === correctAnswer;
        
        if (!isCorrect) {
          continue; // No points for incorrect answers
        }
        
        // Award points based on risk condition
        const condition = result.risk_condition;
        if (condition === 'high_risk') {
          totalPoints += 10;
        } else if (condition === 'low_risk') {
          totalPoints += 1;
        } else {
          // default condition
          totalPoints += 5;
        }
        console.log(`Trial ${i + 1}: awarded points "${totalPoints}"`);
      }
      
      // Store total points for recording and display
      this.totalPoints = totalPoints;
      this.$magpie.measurements.total_points = totalPoints;
    }
  }
};
</script>
